
import { Button, Icon, Tooltip } from "antd";
import AuthService from "../utils/AuthService";

const Auth = new AuthService();

const BackToAdminButton = () => {

    const areInGuestSession = () => {
        const tempToken = localStorage.getItem('mp_temp_token_web');
        const guestToken = localStorage.getItem('mp_guest_token');
        return (tempToken && guestToken);
    }

    if (!areInGuestSession()) {
        return null;
    }

    const backToAdminPetshopList = () => {
        const tempAdminToken = localStorage.getItem('mp_temp_token_web');
        Auth.logout();
        Auth.setToken(tempAdminToken);
        localStorage.removeItem('mp_guest_token');
        localStorage.removeItem('mp_temp_token_web');
        window.location.href = '/dashboard';
    }

    return (
        <Tooltip title="Volver al Panel admin" placement="bottom">
            <Button
                style={style.btn}
                onClick={backToAdminPetshopList}
            >
                <div style={style.iconContainer}>
                    <span style={style.btnFont}>⬅</span>
                    <span style={style.btnFont}>Volver</span>
                </div>
            </Button>
        </Tooltip>
    )
}

const style = {
    btn: {
        height: 50,
        backgroundColor: 'deepskyblue',
        borderRadius: 100,
        position: 'fixed',
        top: 70,
        right: 10,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 16px rgba(0,0,0,0.25)'
    },
    btnFont: { fontSize: 20, zIndex: 9999, color: "white" },
    iconContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        gap: 10
    }
};

export default BackToAdminButton;